module.exports = __webpack_public_path__ + "static/workspace_topology_view-854e208cc9cfa28d0addb0ffe9ab57b5.png";